import Vue from 'vue'

export const Pages = Vue.component('pages', require('./pages.vue'));

export const PageHome = Vue.component('page-home', require('./page-home'));
export const NearPrograms = Vue.component('near-programs', require('./near-programs.vue'));
export const NearProgramsMap = Vue.component('near-programs-map', require('./near-programs-map.vue'));
export const NearProgramsResults = Vue.component('near-programs-results', require('./near-programs-results.vue'));




// WEBPACK FOOTER //
// ./resources/assets/js/views/pages/index.js